// Copyright (c) 2016 Deere & Company

import './demo-rental-history-report.scss';
import React, {
    Component,
    PropTypes
} from 'react';
import Criteria from '../state/criteria';
import Dealer from '@deere/cps-it.warranty-model-factory/lib/dealer';
import DemoRentalHistory from '@deere/cps-it.warranty-model-factory/lib/demo-rental-history';
import DemoRentalHistoryReportCriteria from './demo-rental-history-report-criteria';
import FavoriteIcon from '../../../shared/components/favorites/favorite-icon';
import {FormattedMessage} from 'react-intl';
import Formatting from '../state/formatting';
import KeyValuePair from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';
import NumberOfRecordsFound from '../../../shared/components/number-of-records-found/index';
import ReportGrid from '../../shared/components/report-grid';
import ReportHeader from '../../shared/components/report-header';
import ReportHiddenColumns from '../../shared/components/report-columns';
import ReportLayout from '@deere/cps-it.warranty-model-factory/lib/report-layout';
import ShowNoResultsFound from '../../shared/components/show-no-results-found/show-no-results-found';
import View from '../state/view';
import WarrantyAgGridDatePicker from '../../shared/components/ag-grid-date-picker';
import WarrantyLoadingIndicator from '../../../shared/components/warranty-loading-indicator';
import {exportToCSV} from '../../../reports/shared/services/export-to-csv';
import {getAgGridLocaleText} from '../../../shared/utils/ag-grid-locale-text';
import {getDefaultReportLayout} from '../../shared/services/report-variant';
import {getDemoRentalHistoryColumnDefinitions} from '../report-services/column-definitions';
import {getDemoRentalReportCriteria} from '../../shared/services/reports';
import {getUpdatedAccounts} from '../../shared/services/dealer-accounts';
import {scrollToAndResizeReport} from '../../shared/services/scroll-window';

function handleSelectedAccountsChange(allowedAccount, isSelected) {

    const updatedAccounts = getUpdatedAccounts(this.props.criteria.dealers, allowedAccount, isSelected);

    this.props.actions.updateDemoRentalAccountsCriteria(updatedAccounts);

}

function handleStatusChange(status) {

    this.props.actions.updateDemoRentalAttributesCriteria('status', status);

}

function handleBranchChange(branch) {

    this.props.actions.updateDemoRentalAttributesCriteria('branch', branch);

}

function handleFactoryChange(factory) {

    this.props.actions.updateDemoRentalAttributesCriteria('factoryCode', factory);

}

function handleProductRegisteredChange(event) {

    const productRegistered = event.target.value;

    this.props.actions.updateDemoRentalAttributesCriteria('productRegistered', productRegistered);

}

function handleBeginDateChange(beginDateRange) {

    this.props.actions.updateBeginDate(beginDateRange);

}

function handleEndDateChange(endDateRange) {

    this.props.actions.updateEndDate(endDateRange);

}

function handlePinChange(event) {

    const pin = event.target.value;

    this.props.actions.updateDemoRentalAttributesCriteria('pin', pin);

}

function handleCreateDemoRentalReport() {

    this.props.actions.toggleReportIsScrollable();
    this.props.actions.resetSearchResults();

    const demoRentalHistoryReport = getDemoRentalReportCriteria(this.props.criteria);

    this.props.actions.createDemoRentalHistoryReport(demoRentalHistoryReport);

}

function handleGridApiDefinition(params) {

    let defaultColumnState,
        defaultSortModel;

    this.actions.createAgGridApi(params.api, params.columnApi);

    if (this.selectedLayout && this.selectedLayout.name && !this.isInitialLoad) {

        const defaultLayout = this.layouts.find(layout => !layout.name);

        defaultColumnState = defaultLayout.columnState;
        defaultSortModel = defaultLayout.sortModel;

    } else {

        defaultColumnState = params.columnApi.getColumnState();
        defaultSortModel = params.api.getSortModel();

        this.actions.updateReportProperty('isInitialLoad', false);

    }

    this.actions.updateDefaultLayout(defaultColumnState, defaultSortModel);

    if (this.selectedLayout && this.selectedLayout.name) {

        params.columnApi.setColumnState(this.selectedLayout.columnState);
        params.api.setSortModel(this.selectedLayout.sortModel);
        params.api.setFilterModel(this.selectedLayout.filterModel);

    } else {

        const defaultLayout = getDefaultReportLayout(defaultColumnState, defaultSortModel);

        this.actions.updateReportProperty('selectedLayout', defaultLayout);

    }

}

function onColumnRemoved(columnEvent) {

    if (!columnEvent.visible) {

        this.actions.hideReportColumn(this.columnApi.getColumnState());

    }

}

function handleExportToCsv() {

    const fileName = 'demo-rental-history';

    return exportToCSV(fileName, this.gridApi);

}

function handleSelectAllDealers() {

    this.props.actions.updateDemoRentalSelectAllAccountsCriteria(this.props.allowedAccounts);

}

function handleCriteriaReset() {

    this.actions.updateEndDate('');
    this.actions.updateBeginDate('');
    this.actions.updateDemoRentalAccountsCriteria(this.allowedAccounts);
    this.actions.updateDemoRentalAttributesCriteria('productRegistered', 'YES');
    this.actions.updateDemoRentalAttributesCriteria('factoryCode', '');
    this.actions.updateDemoRentalAttributesCriteria('status', '');
    this.actions.updateDemoRentalAttributesCriteria('pin', '');
    this.actions.updateDemoRentalAttributesCriteria('branch', '');
    this.actions.resetSearchResults();
    this.actions.updateShowNoResultsFound(false);

}

class DemoRentalHistoryReport extends Component {

    componentWillMount() {

        this.props.actions.updateDemoRentalAccountsCriteria(this.props.allowedAccounts);
        this.props.actions.updateDemoRentalStatuses();
        this.props.actions.updateDemoRentalBranches();
        this.props.actions.updateDemoRentalFactoryCodes();
        this.props.actions.updateDemoRentalAttributesCriteria('productRegistered', 'YES');
        this.props.actions.getReportLayouts('demo-rental-history');

    }

    componentDidUpdate(prevProps) {

        if (this.props.reportIsScrollable && this.props.report.length) {

            this.props.actions.resetReportIsScrollable();

            scrollToAndResizeReport();

        }

        const isFirstRun = !prevProps.report.length && !prevProps.showNoResultsFound;
        const layoutWasChanged = this.props.selectedLayout !== prevProps.selectedLayout;
        const readyToApplyLayout = this.props.selectedLayout && Object.keys(this.props.columnApi).length && this.props.isDefaultColumnStateAvailable;

        if ((isFirstRun || layoutWasChanged) && readyToApplyLayout) {

            this.props.columnApi.setColumnState(this.props.selectedLayout.columnState);
            this.props.gridApi.setSortModel(this.props.selectedLayout.sortModel);
            this.props.gridApi.setFilterModel(this.props.selectedLayout.filterModel);

        }

    }

    componentWillUnmount() {

        this.props.actions.resetSearchResults();
        this.props.actions.updateShowNoResultsFound(false);
        this.props.actions.updateDemoRentalAttributesCriteria('status', '');
        this.props.actions.resetReportVariant();

    }

    render() {

        const canRunReport = this.props.criteria.dealers.length > 0 && this.props.criteria.status !== '';

        const gridOptions = {
            dateComponentFramework: WarrantyAgGridDatePicker
        };

        return (
            <section className='demo-rental-history-report'>
                <WarrantyLoadingIndicator isLoading={this.props.busyCounter > 0}/>
                <h2 className='demo-rental-history-title'>
                    <FormattedMessage id='DEMO_RENTAL_HISTORY'/>
                    <FavoriteIcon
                        id='DEMO_RENTAL_HISTORY'
                        route={this.props.pathName}
                    />
                </h2>
                <DemoRentalHistoryReportCriteria
                    allowedAccounts={this.props.allowedAccounts}
                    branch={this.props.criteria.branch}
                    branches={this.props.branches}
                    canExport={this.props.report.length > 0}
                    canRunReport={canRunReport}
                    criteria={this.props.criteria}
                    factoryCode={this.props.criteria.factoryCode}
                    factoryCodes={this.props.factoryCodes}
                    onBeginDateChange={this::handleBeginDateChange}
                    onBranchChange={this::handleBranchChange}
                    onCriteriaReset={this.props::handleCriteriaReset}
                    onEndDateChange={this::handleEndDateChange}
                    onExportToCsv={this.props::handleExportToCsv}
                    onFactoryChange={this::handleFactoryChange}
                    onPinChange={this::handlePinChange}
                    onProductRegistered={this::handleProductRegisteredChange}
                    onRunReport={this::handleCreateDemoRentalReport}
                    onSelectAllDealers={this::handleSelectAllDealers}
                    onSelectedAccountsChange={this::handleSelectedAccountsChange}
                    onStatusChange={this::handleStatusChange}
                    pin={this.props.criteria.pin}
                    productRegistered={this.props.criteria.productRegistered}
                    status={this.props.criteria.status}
                    statuses={this.props.statuses}
                />
                {this.props.report.length ?
                    <div>
                        <NumberOfRecordsFound count={this.props.report.length}/>
                        <section className='report'>
                            {this.props.isReportColumnsVisible && <ReportHiddenColumns/>}
                            <ReportHeader
                                columnApi={this.props.columnApi}
                                gridApi={this.props.gridApi}
                                reportName='demo-rental-history'
                            />
                            <ReportGrid
                                columnDefs={getDemoRentalHistoryColumnDefinitions()}
                                gridOptions={gridOptions}
                                localeText={getAgGridLocaleText()}
                                onColumnVisible={this.props::onColumnRemoved}
                                onGridReady={this.props::handleGridApiDefinition}
                                rowData={this.props.report}
                            />
                        </section>
                    </div> :
                    <ShowNoResultsFound showNoResultsFound={this.props.showNoResultsFound}/>}
            </section>
        );

    }

}

DemoRentalHistoryReport.displayName = 'DemoRentalHistoryReport';
DemoRentalHistoryReport.propTypes = {
    actions: PropTypes.object.isRequired,
    allowedAccounts: PropTypes.arrayOf(PropTypes.instanceOf(Dealer)).isRequired,
    branches: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)).isRequired,
    busyCounter: PropTypes.number.isRequired,
    columnApi: PropTypes.object.isRequired,
    criteria: PropTypes.instanceOf(Criteria).isRequired,
    factoryCodes: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)).isRequired,
    formatting: PropTypes.instanceOf(Formatting).isRequired,
    gridApi: PropTypes.object.isRequired,
    isDefaultColumnStateAvailable: PropTypes.bool.isRequired,
    isInitialLoad: PropTypes.bool.isRequired,
    isReportColumnsVisible: PropTypes.bool.isRequired,
    layouts: PropTypes.arrayOf(PropTypes.instanceOf(ReportLayout)).isRequired,
    pathName: PropTypes.string.isRequired,
    report: PropTypes.arrayOf(PropTypes.instanceOf(DemoRentalHistory)),
    reportIsScrollable: PropTypes.bool.isRequired,
    selectedLayout: PropTypes.instanceOf(ReportLayout),
    showNoResultsFound: PropTypes.bool.isRequired,
    statuses: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)).isRequired,
    views: PropTypes.arrayOf(PropTypes.instanceOf(View)).isRequired
};

export default DemoRentalHistoryReport;



// WEBPACK FOOTER //
// ./src/reports/demo-rental-history/components/demo-rental-history-report.js